import { Directive, inject, TemplateRef } from '@angular/core';
/**
 * @example
 * <ng-template
 *  siatTableExpansion
 *   let-items>
 *    <div>
 *     {{ item }}
 *    </div>
 * </ng-template>
 */
@Directive({
   
  selector: '[siatTableExpansion]',
})
export class TableExpansionDirective {
  templateRef = inject(TemplateRef);
}
